import { I18n } from '@calendly/i18n';
import { Badge, BADGE_TYPE_INFO } from '@calendly/ui/components/badge';
import { DropdownMenu, DropdownMenuContent, DropdownMenuGroup, DropdownMenuGroupTitle, DropdownMenuItem, DropdownMenuTrigger } from '@calendly/ui/components/dropdown-menu';
import { IconCalendarPlus } from '@calendly/ui/components/glyphs/IconCalendarPlus';
import { IconCheck } from '@calendly/ui/components/glyphs/IconCheck';
import { IconMail } from '@calendly/ui/components/glyphs/IconMail';
import { IconSettings } from '@calendly/ui/components/glyphs/IconSettings';
import { IconButton } from '@calendly/ui/components/icon-button';
import { BodyText, LabelText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { useState } from 'react';

// i18n-tasks-use t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.calendar_invitation')
// i18n-tasks-use t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.calendar_invitation_description')
// i18n-tasks-use t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.email_confirmation')
// i18n-tasks-use t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.email_confirmation_description')
// i18n-tasks-use t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.recommended')
// i18n-tasks-use t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.section_title')
// i18n-tasks-use t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.settings_title')

const CONFIRMATION_TYPE_OPTIONS = [{
  sectionKey: 'calendar_invitation',
  notificationType: 'calendar',
  icon: IconCalendarPlus,
  title: () => I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.calendar_invitation'),
  description: () => I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.calendar_invitation_description'),
  recommended: true
}, {
  sectionKey: 'email_confirmation',
  notificationType: 'email',
  icon: IconMail,
  title: () => I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.email_confirmation'),
  description: () => I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.email_confirmation_description')
}];
const menuCss = "m16zed5g";
const sectionTitleCss = "sgbvp44";
const menuItemContentCss = "m1m282fs";
const menuItemHeaderCss = "m181lt8b";
const menuItemTitleCss = "m1d8nx2n";
const iconSpacerCss = "ity2arx";
const CONFIRMATION_TYPE_SECTION_KEYS = CONFIRMATION_TYPE_OPTIONS.map(({
  sectionKey
}) => sectionKey);
export const isConfirmationTypeSectionKey = sectionKey => CONFIRMATION_TYPE_SECTION_KEYS.includes(sectionKey);
export const getConfirmationTypeSectionTitle = sectionKey => {
  const option = CONFIRMATION_TYPE_OPTIONS.find(({
    sectionKey: key
  }) => key === sectionKey);
  return option ? option.title() : '';
};
export const getConfirmationTypeForSectionKey = sectionKey => CONFIRMATION_TYPE_OPTIONS.find(({
  sectionKey: key
}) => key === sectionKey)?.notificationType;
const ConfirmationTypeMenuItem = ({
  sectionKey,
  icon,
  title,
  description,
  selected,
  recommended,
  onSelect
}) => <DropdownMenuItem onSelect={onSelect} data-testid={`confirmation-type-option-${sectionKey}`}>
    <div className={menuItemContentCss}>
      <div className={menuItemHeaderCss}>
        <UiIcon icon={icon} size="small" title="" />
        <LabelText size="medium" className={menuItemTitleCss}>
          {title}
        </LabelText>
        {recommended ? <Badge type={BADGE_TYPE_INFO}>
            {I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.recommended')}
          </Badge> : null}
        {selected ? <UiIcon icon={IconCheck} size="small" title="" data-testid="confirmation-type-checkmark" /> : null}
      </div>
      <div className={menuItemHeaderCss}>
        <div className={iconSpacerCss} aria-hidden="true" />
        <BodyText color="muted" size="small">
          {description}
        </BodyText>
      </div>
    </div>
  </DropdownMenuItem>;

// Settings menu for switching between calendar invitation and email confirmation
// while editing a confirmation notification in the CRUD drawer.
export const ConfirmationTypeSettingsMenu = ({
  selectedSectionKey,
  onSelect
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <DropdownMenu isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <DropdownMenuTrigger>
        <IconButton appearance="ghost" size="medium" icon={IconSettings} onClick={() => setIsOpen(open => !open)} aria-expanded={isOpen} aria-haspopup="menu" title={I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.settings_title')} aria-label={I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.settings_title')} data-testid="confirmation-type-settings-trigger" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className={menuCss} placement="bottom end" data-testid="confirmation-type-settings-menu">
        <DropdownMenuGroup>
          <DropdownMenuGroupTitle className={sectionTitleCss}>
            {I18n.t('publisher.event_type_editor.sections.more_options.notifications.confirmation_type.section_title')}
          </DropdownMenuGroupTitle>
          {CONFIRMATION_TYPE_OPTIONS.map(option => <ConfirmationTypeMenuItem key={option.sectionKey} sectionKey={option.sectionKey} icon={option.icon} title={option.title()} description={option.description()} recommended={option.recommended} selected={selectedSectionKey === option.sectionKey} onSelect={() => {
          if (selectedSectionKey !== option.sectionKey) {
            onSelect(option.sectionKey);
          }
          setIsOpen(false);
        }} />)}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>;
};

require("./confirmation_type_settings_menu.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./confirmation_type_settings_menu.js");